import $ from 'jquery';
import {
  ST_TEXTS,
  alertMessagePopup,
  attendeeAttachPhotosByQR,
  customPopUp,
  getParameterByName,
  getQueryVariable,
  hideLoading,
  remoteCapture,
  showLoading,
  trackListOfPhotoEvent,
  trackPhotoEvent,
  isMobile,
  pAttendeeAttachPhotosByQR,
  deleteImagesReq,
  isIPhone,
  initMultipleDownload,
  showBlockingError,
} from './utils-module.js';
import * as fullScreenView from './fullScreenView.js';
import { customImageUpload, uploadSelfieImage } from './uploadPhotosUtil.js';
import { generateUrlForEmail } from './registration/index.js';
import { updateQRMenuText } from './view-behavior.js';
import {
  findAttendeeByUIDAndEventId,
  findPhotos,
  print,
  captureEvents,
  addVisitDateInfo,
  findEvent,
} from '../../../packages/src/api/index.js';
import { occoApi } from './occoAPI-module.js';
import { initWaitingNotice } from './waitingNotice.js';
import { initModeSwitcher } from './modeSwitcher.js';
import { initSelect } from './select.js';
import { initGalleryViewController } from './imageList.js';
import { initActionPanel } from './actionPanel.js';
import { initSelectedPanel } from './panel-selected.js';
import { init as initZendesk } from './zendesk.js';
import * as photoDC from './photoDS.js';
import { pageParams } from './page.js';
import LANG from '../lang/prop-en-module.js';
import * as createAStoryBtn from './createAStoryBtn.js';
import * as createAStory from './createAStory.js';
import { setLogo } from './customizePage/home.js';
import multiAccounts from './multiAccounts/index.ts';
import * as multiAccountsView from './multiAccounts/view.ts';
import { initEventOrganisationDataStorage } from '../../../packages/src/eventOrganisationDataStorage.js';
import { checkIncognitoMode } from './incognito-detector.js';

import 'bootstrap';
import '../libs/js/jquery-qrcode-0.15.0.min.js';
import '../libs/js/qrcode-reader.min.js';
import {
  getWatermarkSrc,
  initAccessDataStorage,
  initWatermarkStorage,
  isAvailableToUsePhoto,
  isEnabledWatermarkBySrc,
  makeAccessData,
} from './accessData.js';
import * as UGC from './Tooltips/ugc.js';
import * as faceReco from './Tooltips/faceReco.js';
import { prepareSharePage, shareUrl } from './sharedAccount.js';
import { transformS3UrlToShareDomain } from '../../../packages/src/utils/domain.js';
import * as shareBucketApi from '../../../packages/src/api/shareInBucket.js';
import { redirectToPage } from './page-routes.js';
import * as homePageDispatcher from './homePageDispatcher.ts';
import { selectCurrentAccount, syncMultiAccounts } from './multiAccounts/mainController.ts';
import { isSessionExpired } from './utils/session.js';
import { calculateExpiredDate } from './multiAccounts/data.ts';
import { initLoc, saveLocParams, setTextToElement, t } from './localization.js';

const isSharingInProgress = false;
const MAX_NUMBER_OF_PHOTOS = 3000;

const { saveEventName, saveHomeLink, saveAttendeeUid } = pageParams;

const waitingNotice = initWaitingNotice();
const modeSwitcher = initModeSwitcher();
const selectImage = initSelect();
const galleryVC = initGalleryViewController();
const actionPanel = initActionPanel();
const selectedPanel = initSelectedPanel();
const multipleDownload = initMultipleDownload(waitingNotice);

let actionPanelButtons = [];

const watermarkStorage = initWatermarkStorage();
const accessDataStorage = initAccessDataStorage();
const eventOrganisationDataStorage = initEventOrganisationDataStorage();
accessDataStorage.setData(makeAccessData());

// Helper functions moved to outer scope
async function fetchAccountData(parsedQueryParams) {
  showLoading();
  let eventData;
  try {
    const response = await findEvent({ eventName: parsedQueryParams.eventCode, basicDataOnly: true });
    eventData = response.result;

    if (!eventData) {
      const errorMessage = parsedQueryParams.eventCode
        ? `This "${parsedQueryParams.eventCode}" event name (eName) doesn't exist. Please use right event name`
        : "The event code is missing. Please make sure you're using the correct link or QR code. If you continue to see this message, please contact support for assistance.";
      showBlockingError(errorMessage);
      return;
    }
  } catch (e) {
    console.error(e);
    showBlockingError(
      'An error occurred while loading the event. Please try again later or contact support if the problem persists.'
    );
    return;
  }

  const res = await findAttendeeByUIDAndEventId(parsedQueryParams.attendeeUid, eventData.id);

  return {
    attendeeUid: parsedQueryParams.attendeeUid,
    eventCode: parsedQueryParams.eventCode,
    eventLogo: eventData.opts.webappCustomLogoSrc,
    name: res.result.full_name,
    email: res.result.email_address || res.result.email,
    phoneNumber: res.result.phone_number,
    regDate: new Date(res.result.created_date),
    expiredDate: calculateExpiredDate(eventData, res.result),
  };
}

function isValidToken(tokenA, tokenB) {
  if (!tokenA || !tokenB) return false;
  return tokenA === tokenB;
}

function getStepOfReg() {
  return localStorage.getItem('step') || '2';
}

function goToFirstStep() {
  localStorage.setItem('step', '1');
}

function isEmptyParsedOpts(parsedOpts) {
  return Object.keys(parsedOpts || {}).length === 0;
}

function filterKeys(keys) {
  return (_, key) => !keys.includes(key);
}

function filterQuery(predicate) {
  const queryArray = [];
  new URLSearchParams(globalThis.location.search).forEach((value, key) => {
    if (predicate(value, key)) {
      queryArray.push([value, key]);
    }
  });
  return queryArray.reduce((acc, [value, key]) => {
    const and = acc === '' ? '?' : '&';
    return `${acc}${and}${key}=${value}`;
  }, '');
}

function updatePageQueryString(queryString) {
  if (queryString === '') {
    globalThis.location.href = globalThis.location.origin + globalThis.location.pathname;
  } else {
    globalThis.location.search = queryString;
  }
}

function isNeedToShowPrivacy(opts) {
  return !isEmptyParsedOpts(opts) && Boolean(opts.agreementText);
}

function OCCOAppPages() {
  const DEFAULT_TEXT_WAITING_STORIES =
    'Your story is being generated. Refresh your album in a couple of minutes to see your video.';
  const DISABLED_SHARE_MSG = 'Select images you would like to share';
  const DISABLED_MULTIPLE_DOWNLOAD_MSG = 'Select images you would like to download';
  const DISABLED_SHARE_MSG_BECAUSE_WATERMARK = 'Select images without watermark';
  const DISABLED_SHARE_MSG_BECAUSE_WATERMARK_MULTIPLE_DOWNLOAD = 'Select images without watermark';
  const DISABLED_DELETE_MSG = 'Select images you would like to delete';
  const LOCKED_SHARE_MSG =
    'Some of the images you selected are still locked. You can unlock digital images by purchasing a digital pass. \n \n Click on the card icon above to purchase.';
  const LOCKED_MULTIPLE_DOWNLOAD_MSG =
    'Some of the images you selected are still locked. You can unlock digital images by purchasing a digital pass. \n \n Click on the card icon above to purchase.';
  let IMAGE_DATA = [];
  const self = this;
  let ATT_ID = null;
  let EVENT_NAME = null;
  let EVENT_DATA = null;
  let EVENT_OPTS = null;
  let SHIPPING_ADDRESS = null;
  let HAS_FULL_IMAGE_ACCESS = 1;
  let ATTENDEE_STATE = {};
  let VISIT_DATE = null;
  let FACE_RECO = true;
  let isDisableSelfies = false;
  let isEnableFaceRec = false;
  let AUTO_RC = null;

  this.init = async function () {
    multiAccountsView.render(multiAccounts.getList(), multiAccounts.getCurrentIndex());
    const parsedQueryParams = {
      attendeeUid: getQueryVariable('uId'),
      eventCode: getQueryVariable('eName'),
      fr: getQueryVariable('fr'),
      imgSrc: getQueryVariable('imgSrc'),
      photoId: getQueryVariable('photoId'),
      token: getQueryVariable('token'),
      uploadUGC: getQueryVariable('uploadUGC'),
      tg: getQueryVariable('tg'),
      showQR: getQueryVariable('showQR'),
      aiKiosk: getQueryVariable('aiKiosk'),
      ignoreIncognito: getQueryVariable('iic'),
      afterIncognito: getQueryVariable('aim'),
    };

    await selectCurrentAccount({
      parsedQueryParams,
      multiAccounts,
      fetchAccountData,
    });

    await syncMultiAccounts({ multiAccounts });

    const currentAccount = multiAccounts.getCurrentAccount();
    if (currentAccount) {
      ATT_ID = currentAccount.attendeeUid;
      EVENT_NAME = currentAccount.eventCode;
    } else {
      ATT_ID = parsedQueryParams.attendeeUid;
      EVENT_NAME = parsedQueryParams.eventCode;
    }

    if (isUidNull()) {
      await captureEvents({
        EventSource: 'Phone',
        EventName: 'NULL_WEBAPP_UID',
        EventType: 'info',
        EventCode: EVENT_NAME,
        EventHref: globalThis.location.href,
      });
      pageParams.resetData();
      updatePageQueryString(filterQuery(filterKeys(['uId'])));
      return;
    }

    if (multiAccounts.getList().length === 0 && !EVENT_NAME) {
      showBlockingError('No albums found. Please scan a QR code or use a valid link to access your photos.');
      return;
    }
    AUTO_RC = getQueryVariable('rc') === 'true';
    FACE_RECO = getQueryVariable('fr') !== 'false';

    if (AUTO_RC === true) {
      if (localStorage.getItem('locWA')) {
        localStorage.setItem('home', generateUrlForEmail());
      }
    } else {
      localStorage.setItem('home', globalThis.location.href);
    }

    showLoading();
    let result;
    try {
      const response = await findEvent({ eventName: EVENT_NAME, basicDataOnly: true });
      result = response.result;
    } catch (e) {
      showBlockingError(
        'An error occurred while loading the event. Please try again later or contact support if the problem persists.'
      );
      return;
    }
    if (!result) {
      showBlockingError(`This "${EVENT_NAME}" event name (eName) doesn't exist. Please use right event name`);
      return;
    }
    saveLocParams({ orgId: result.organisation?.id, eventCode: result.name });
    await initLoc();

    if (result.organisation) {
      eventOrganisationDataStorage.storeEventOrganisationData(result.organisation);
    }

    hideLoading();

    actionPanelButtons = [
      // { id: 'share', iconName: 'share', text: isIPhone() ? 'Share/Download' : 'Share' },
      { id: 'shareLink', iconName: 'share', text: 'Share' },
      { id: 'multipleDownload', iconName: 'download', text: 'Download' },
      { id: 'purchase', iconName: 'payment', text: t('purchase-btn') },
      { id: 'delete', iconName: 'delete', text: 'Delete' },
    ];
    setTextToElement('.float-button .purchase-btn', t('purchase-btn'));

    const { opts } = result;

    // NOTE: needs for debugging options
    console.log('opts', opts);

    EVENT_DATA = result;
    if (opts) {
      EVENT_OPTS = result.opts;
    }

    logPhotoDelayValues();

    if (result.shopify_shipping_address) {
      SHIPPING_ADDRESS = result.shopify_shipping_address;
    }

    watermarkStorage.setSrc(EVENT_DATA.protector_watermark);

    // NOTE: for test initZendesk('dbfef4a1-5495-4537-a555-df6c1689140e');
    initZendesk(opts.zendeskKey);

    const isShowPrivacyLink = isNeedToShowPrivacy(opts);

    VISIT_DATE = 1;
    $('#eventLogoCont').css('display', 'flex');
    if (AUTO_RC === true) {
      const codeMRC1 = getQueryVariable('mrc1');
      remoteCapture(ATT_ID, codeMRC1);
    }

    saveHomeLink(globalThis.location.href);
    $('#selfie').hide();

    if (isEmptyParsedOpts(opts)) {
      showBlockingError('Event configuration is missing. Please contact support for assistance.');
      return;
    }

    isDisableSelfies = !FACE_RECO || opts.isDisableSelfies;
    isEnableFaceRec = !FACE_RECO || EVENT_DATA.enable_facial_recognition === 1;

    if (isDisableSelfies || !isEnableFaceRec) {
      UGC.show();
      faceReco.off();
      $('#selfies').hide();
    } else if (isEnableFaceRec) {
      faceReco.reset();
    }

    const mode = homePageDispatcher.getMode({
      parsedQueryParams,
      eventOpts: opts,
      stepReg: getStepOfReg(),
      account: multiAccounts.getCurrentAccount(),
    });

    if (mode.startsWith('registrationByIdFirst')) {
      goToFirstStep();
      saveEventName(EVENT_NAME);

      const isIncognito = await checkIncognitoMode();

      if (isIncognito && parsedQueryParams.ignoreIncognito !== 'true') {
        redirectToPage.incognitoMode({ rawSearch: globalThis.location.search });
      } else {
        // Capture event if user successfully exited incognito mode
        if (parsedQueryParams.afterIncognito === 'true') {
          captureEvents({
            EventSource: 'WebApp',
            EventName: 'SuccessfullyExitedIncognitoModePage',
            EventType: 'info',
            EventHref: globalThis.location.href,
          });
        }
        redirectToPage.registration.showIdFirst({
          rawSearch: filterQuery(filterKeys(['aim'])),
        });
      }
    } else if (mode.startsWith('registrationByDefault')) {
      saveEventName(EVENT_NAME);
      redirectToPage.registration.normal({ rawSearch: globalThis.location.search });
    } else if (mode === 'showQR') {
      self.showQRcode();
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['showQR']))));
    } else if (mode === 'addUGC') {
      handlePhotoUpload();
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['uploadUGC', 'tg']))));
    } else if (mode === 'turnMeIntoTag') {
      handlePhotoUpload({
        prefixFileName: getQueryVariable('tg'),
        ugcUploadMessage: EVENT_OPTS.TMITUploadMessage ? EVENT_OPTS.TMITUploadMessage : LANG.TMITUploadMessage,
        asyncUgcUploadText: EVENT_OPTS.TMITProcessMessage ? EVENT_OPTS.TMITProcessMessage : LANG.TMITProcessMessage,
      });
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['tg']))));
    } else if (mode === 'aiKiosk') {
      const aiKioskImageSrc = getQueryVariable('aiKioskImgSrc');
      if (aiKioskImageSrc) {
        handlePhotoAIPhotoAttach(aiKioskImageSrc);
      }
      onCloseModal(() => updatePageQueryString(filterQuery(filterKeys(['aiKioskImgSrc', 'aiKiosk']))));
    } else if (mode === 'addPhoto') {
      await captureEvents({
        EventSource: 'Phone',
        EventName: 'QRScan',
        EventType: 'info',
        EventCode: EVENT_NAME,
      });
      showScannedImage(
        {
          scannedImgSrc: getQueryVariable('imgSrc'),
          photoUId: getQueryVariable('photoId'),
        },
        {
          isHideAfterFinish: false,
          onSubmit: async (photoUId) => {
            showLoading();
            await pAttendeeAttachPhotosByQR(ATT_ID, [photoUId]);
          },
          onFinish: () => {
            updatePageQueryString(filterQuery(filterKeys(['imgSrc', 'photoId'])));
          },
        }
      );
    } else if (mode === 'unlock') {
      if (isValidToken(getQueryVariable('token'), opts.vipToken)) {
        showLoading();
        await unlockAccount();
      }
      updatePageQueryString(filterQuery(filterKeys(['token'])));
    } else if (mode === 'contactCompletion') {
      redirectToPage.contactCompletion({ rawSearch: globalThis.location.search });
    } else if (mode === 'openLinkByEmail' || mode === 'default') {
      await defaultCase({ isShowPrivacyLink, isDisableLinkPhotos: opts.isDisableLinkPhotos });
    }

    if (parsedQueryParams.eventCode || parsedQueryParams.attendeeUid) {
      updatePageQueryString(filterQuery(filterKeys(['eName', 'uId'])));
    }

    fullScreenView.onShareBtn(self.newShareImage);
    fullScreenView.onDownloadBtn(self.newDownloadImage);
  };

  async function defaultCase({ isShowPrivacyLink, isDisableLinkPhotos }) {
    saveEventName(EVENT_NAME);
    setLogo(EVENT_OPTS.webappCustomLogoSrc);
    multiAccountsView.render(multiAccounts.getList(), multiAccounts.getCurrentIndex());
    multiAccountsView.onSelectAccount(multiAccounts.setCurrentAccount);
    multiAccounts.onChangeCurrentIndex(multiAccountsView.activeAccount);
    multiAccounts.onChangeCurrentIndex(() => {
      globalThis.location.reload();
    });
    initShopify();
    await getImageList(EVENT_DATA.id);

    initBottomMenu({ isShowPrivacyLink });
    initQRReader({ isDisableLinkPhotos });
  }

  async function unlockAccount() {
    await addVisitDateInfo({
      eventName: EVENT_NAME,
      uId: ATT_ID,
      vDate: new Date(),
      prePaid: true,
    });
  }

  function initBottomMenu({ isShowPrivacyLink = false } = {}) {
    if (VISIT_DATE === 1) {
      $('#selfie').on('click', () => {
        showFaceRegister(true);
      });
    } else {
      $('#selfie').hide();
    }

    if (isShowPrivacyLink) {
      $('#privacy-link').removeClass('menu__item_hidden');
    }

    $('.emit-select-combo').on('click', async function () {
      const $purchaseBtn = $(this);
      await captureEventClickPurchaseButton($purchaseBtn);
      localStorage.setItem('allPhotos', JSON.stringify(IMAGE_DATA));
      const account = multiAccounts.getCurrentAccount();
      if (account) {
        saveAttendeeUid(account.attendeeUid);
        saveEventName(account.eventCode);
      }
      redirectToPage.combos();
    });

    $('.emit-select-photos').on('click', () => {
      modeSwitcher.switchToSelect();
      IMAGE_DATA.forEach((photo) => {
        selectImage.select(photo.id);
      });
    });

    $('#uploadPhotoBtn').on('click', () => {
      handlePhotoUpload();
    });
  }

  async function captureEventClickPurchaseButton($btn) {
    if (!$btn.hasClass('purchase-btn_big') && !$btn.hasClass('purchase-btn_small')) return;

    await captureEvents({
      EventName: getCaptureEventName(),
      EventType: 'info',
      EventSource: 'WebApp',
      AttendeeUid: ATT_ID,
      EventCode: EVENT_NAME,
      Count: 1,
    });

    function getCaptureEventName() {
      if ($btn.hasClass('purchase-btn_big')) return 'ClickBigPurchaseButton';
      if ($btn.hasClass('purchase-btn_small')) return 'ClickSmallPurchaseButton';
    }
  }

  function initShopify() {
    localStorage.setItem('shopDomain', EVENT_OPTS.shopDomain);
    localStorage.setItem('shopToken', EVENT_OPTS.shopToken);
    localStorage.setItem('shopDigitalVariantId', EVENT_OPTS.shopPlusId);
    localStorage.setItem('hideProductPrice', EVENT_OPTS.hideProductPrice ? EVENT_OPTS.hideProductPrice : 0);

    if (EVENT_OPTS.shopDigitalProductMsg) {
      localStorage.setItem('shopDigitalProductMsg', EVENT_OPTS.shopDigitalProductMsg);
    }
    if (EVENT_OPTS.shopDigitalProductDupMsg) {
      localStorage.setItem('shopDigitalProductDupMsg', EVENT_OPTS.shopDigitalProductDupMsg);
    }
    localStorage.setItem('shopifyCollections', EVENT_OPTS.prodCollects);
    localStorage.setItem('shippingAddress', SHIPPING_ADDRESS);
    localStorage.setItem('enabledShopComboRequired', EVENT_OPTS.enabledShopComboRequired || false);

    // shopifyReinit();
    // if (EVENT_OPTS.shopDomain && EVENT_OPTS.shopToken) {
    //   shopifyUtil.getCheckout(function (checkout) {
    //     var lineItemsLength = (checkout.lineItems.length || 0);
    //     if (lineItemsLength > 0) {
    //       var $cart = $("#cart");
    //       $cart.addClass("cart-vis ");
    //       $cart.click(function () {
    //         globalThis.location.href = "cart.html";
    //       });
    //       $("#cartCount").html(lineItemsLength);
    //     }
    //   });
    // }
    // Needs to add file
    // <script defer src="js/shopifyUtil.js"></script>
  }

  function logPhotoDelayValues() {
    console.log("Delay public's access to photos for:");
    console.log('- Non-VIP =', getValue(EVENT_OPTS.photoDelayMinutes));
    console.log('- VIP =', getValue(EVENT_OPTS.photoDelayVipMinutes));
    console.log('- TagsMin =', getValue(EVENT_OPTS.photoDelayTagsMinutes));
    console.log('- Tags =', getValue(EVENT_OPTS.photoDelayTags));

    function getValue(minutes) {
      return minutes ? `${minutes} minutes` : 'not set';
    }
  }

  function getImageList(eventId) {
    return findAttendeeByUIDAndEventId(ATT_ID, eventId)
      .then((response) => {
        const shopify_config_exists = EVENT_OPTS?.shopToken && EVENT_OPTS?.shopDomain;
        HAS_FULL_IMAGE_ACCESS = response.result ? +response.result.has_full_image_access : 0;
        ATTENDEE_STATE = response?.result?.unlockState;
        localStorage.setItem('isVip', HAS_FULL_IMAGE_ACCESS);

        if (!HAS_FULL_IMAGE_ACCESS && shopify_config_exists) {
          $('.purchase-btn').show();
        } else {
          $('.purchase-btn').hide();
        }

        accessDataStorage.setData(
          makeAccessData({
            isFreeEvent: Boolean(EVENT_DATA.is_free),
            wasPaid: Boolean(HAS_FULL_IMAGE_ACCESS),
          })
        );

        const minInterval = HAS_FULL_IMAGE_ACCESS ? EVENT_OPTS.photoDelayVipMinutes : EVENT_OPTS.photoDelayMinutes;
        return { minInterval };
      })
      .then(({ minInterval }) =>
        findPhotos({
          eventId,
          attId: ATT_ID,
          minInterval,
          keyType: 'attendee_uid',
          keyValue: ATT_ID,
          maxSize: MAX_NUMBER_OF_PHOTOS,
          show_total_count: true,
        })
      )
      .then((response) => {
        IMAGE_DATA = [...response.result.dataList].sort(comparisonPhotosByWatermark);

        if (VISIT_DATE === 1 && AUTO_RC !== true) {
          checkSelfiesList();
        }

        hideLoading();

        loadGallery();
      })
      .catch((err) => {
        console.error(err);
        if (err && err.resp.error.message_key === 'invalid_uid') {
          hideLoading();
        }
      });
  }

  // activation of user's photo uploading functionality
  function activateUserImageUpload() {
    if (EVENT_OPTS.enableAttendeePhotoUpl) {
      $('#uploadPhotoBtn').css('display', 'block');
      UGC.show(EVENT_OPTS.UGCTooltipText);
    }
  }

  function checkSelfiesList() {
    self.getSelfieList(ATT_ID, (result) => {
      if (result.length === 0 && FACE_RECO && !isDisableSelfies && isEnableFaceRec) {
        $('.add-selfie').show();
        initAppSelfie();
      }
    });
  }

  function is360(photo) {
    return photo.image_type === '360_DEGREE';
  }

  function showFullScreen({ id }) {
    const index = IMAGE_DATA.findIndex((photo) => photo.id === id);
    const access = accessDataStorage.getData();
    fullScreenView.showItems(
      IMAGE_DATA.map((photo) =>
        photoDC.fullScreenVM(photo, {
          watermarkSrc: getWatermarkSrc(photoAccess(photo, access), photo, watermarkStorage.getSrc()),
          canDownload: isAvailableToUsePhoto(photoAccess(photo, access), photo) && !isIPhone(),
          canShare: isAvailableToUsePhoto(photoAccess(photo, access), photo),
        })
      ),
      index
    );
  }

  function stringContainsAny(str, substrings) {
    return substrings.some((substring) => str.includes(substring));
  }

  function isPhotoPaid(photo) {
    let isPaid = false;
    if (ATTENDEE_STATE?.status === 'UNLOCKED') return true;
    if (ATTENDEE_STATE?.tags?.length > 0) {
      isPaid = stringContainsAny(photo.full_path, ATTENDEE_STATE.tags);
    } else if (ATTENDEE_STATE?.photoIds?.length > 0) {
      isPaid = ATTENDEE_STATE.photoIds.includes(photo.id);
    }
    return isPaid;
  }

  function photoAccess(photo, access) {
    return {
      ...access,
      wasPaid: isPhotoPaid(photo),
    };
  }

  function loadGallery() {
    activateUserImageUpload();
    const access = accessDataStorage.getData();
    const photosViewModel = IMAGE_DATA.map((photo) =>
      photoDC.viewModel(photo, {
        watermarkSrc: getWatermarkSrc(photoAccess(photo, access), photo, watermarkStorage.getSrc()),
        canDownload: isAvailableToUsePhoto(photoAccess(photo, access), photo),
      })
    );

    galleryVC.render(photosViewModel, EVENT_DATA.empty_album_text);
    actionPanel.render(actionPanelButtons);

    if (HAS_FULL_IMAGE_ACCESS) {
      actionPanel.hideBtn('purchase');
    } else {
      actionPanel.showBtn('purchase');
    }
    $('.emit-select-photos').show();
    if (isMobile()) {
      actionPanel.showBtn('shareLink');
      actionPanel.disableBtn('delete');
      actionPanel.disableBtn('shareLink');
      modeSwitcher.switchToDefaultMode();
      galleryVC.enableIconType();

      galleryVC.onClick((data) => {
        if (modeSwitcher.isSelectMode()) {
          selectImage.toggle(data.id);
        } else if (modeSwitcher.isDefaultMode()) {
          showFullScreen(data);
        }
      });

      galleryVC.onLongTouch(({ id }) => {
        if (modeSwitcher.isDefaultMode()) {
          selectImage.select(id);
        }
      });

      modeSwitcher.onSelectMode(galleryVC.enableSelect);
      modeSwitcher.onSelectMode(actionPanel.show);
      modeSwitcher.onSelectMode(selectedPanel.show);

      modeSwitcher.onDefaultMode(galleryVC.disableSelect);
      modeSwitcher.onDefaultMode(actionPanel.hide);
      modeSwitcher.onDefaultMode(selectedPanel.hide);

      selectImage.onUpdate((photos) => {
        if (photos.size === 0) {
          modeSwitcher.switchToDefaultMode();
        } else {
          modeSwitcher.switchToSelect();
        }
      });
    } else {
      // NOTE: Desktop
      galleryVC.enableSelect();
      galleryVC.onClick(({ id }) => selectImage.toggle(id));
      galleryVC.enableView();
      galleryVC.onClickView(showFullScreen);

      selectImage.onUpdate((photos) => {
        if (photos.size === 0) {
          actionPanel.hide();
          selectedPanel.hide();
        } else {
          actionPanel.show();
          selectedPanel.show();
        }
      });
    }

    galleryVC.onClickDownloadBtn(self.downloadImage);

    selectImage.onSelect(galleryVC.select);
    selectImage.onUnselect(galleryVC.unselect);
    selectImage.onUnselectAll(galleryVC.unselectAll);

    selectImage.onUpdate((photos) => {
      if (photos.size === 0) {
        actionPanel.disableBtn('shareLink');
        actionPanel.disableBtn('multipleDownload');
      } else {
        const canSharePhoto = [...photos].every((id) => {
          const matchedPhoto = IMAGE_DATA.find((photo) => photo.id === id);
          return !matchedPhoto || isAvailableToUsePhoto(photoAccess(matchedPhoto, access), matchedPhoto);
        });
        if (canSharePhoto) {
          actionPanel.showBtn('shareLink');
          actionPanel.enableBtn('shareLink');
          actionPanel.showBtn('multipleDownload');
          actionPanel.enableBtn('multipleDownload');
        } else {
          actionPanel.disableBtn('shareLink');
          actionPanel.disableBtn('multipleDownload');
        }
      }
    });

    selectImage.onUpdate((photos) => {
      if (photos.size === 0) {
        actionPanel.disableBtn('delete');
      } else {
        actionPanel.enableBtn('delete');
      }
    });

    selectImage.onUpdate((photos) => {
      selectedPanel.updateAmountOfSelect(photos.size);
    });

    if (IMAGE_DATA.filter(isAvailableToUsePhoto(accessDataStorage.getData())).length === 0) {
      actionPanel.disableBtn('shareLink');
    }

    // actionPanel.onClickBtn('share', () => {
    //   if (actionPanel.isDisabledBtn('share')) {
    //     alert(DISABLED_SHARE_MSG);
    //   } else {
    //     const availablePhotos = IMAGE_DATA.filter(photoDC.includesById(selectImage.array())).filter(
    //       isAvailableToUsePhoto(accessDataStorage.getData())
    //     );
    //     if (availablePhotos.length === 0) {
    //       alert(DISABLED_SHARE_MSG_BECAUSE_WATERMARK);
    //     } else {
    //       shareFiles(availablePhotos);
    //     }
    //   }
    // });

    actionPanel.onClickBtn('shareLink', () => {
      if (actionPanel.isDisabledBtn('shareLink')) {
        if (selectImage.array().length === 0) {
          alert(DISABLED_SHARE_MSG);
        } else {
          alert(LOCKED_SHARE_MSG);
        }
      } else {
        const availablePhotos = IMAGE_DATA.filter(photoDC.includesById(selectImage.array()));
        if (availablePhotos.length === 0) {
          alert(DISABLED_SHARE_MSG_BECAUSE_WATERMARK);
        } else {
          shareSharingPage(availablePhotos[0].thumb_full_path, availablePhotos)
            .then(selectImage.unselectAll)
            .catch((error) => {
              alertMessagePopup(error.message);
            });
        }
      }
    });

    actionPanel.onClickBtn('purchase', () => {
      $('.emit-select-combo').trigger('click');
    });

    createAStoryBtn.onClick(() => {
      if (createAStory.allTagsHaveAPhoto(IMAGE_DATA, getRequiredTagsToGenerateStory())) {
        Promise.resolve()
          .then(showLoading)
          .then(() => createAStory.saveLastTime(Date.now()))
          .then(() => createAStoryBtn.hide())
          .then(() =>
            print(
              {
                eventId: EVENT_DATA.id,
                attendeeUid: ATT_ID,
                printerPoolName: EVENT_OPTS.storiesPrintPool,
                photosUid: createAStory
                  .extractPhotosByTags(IMAGE_DATA, getRequiredTagsToGenerateStory())
                  .map((photo) => photo.uid),
                isStory: true,
              },
              {
                keyType: 'event_public_api_key',
                keyValue: EVENT_DATA.public_api_key,
              }
            )
          )
          .then(() => alert(getTextForWaitingStory(EVENT_OPTS)))
          .then(hideLoading);
      }
    });

    actionPanel.onClickBtn('delete', () => {
      if (actionPanel.isDisabledBtn('delete')) {
        alert(DISABLED_DELETE_MSG);
      } else {
        openDeleteImagesModal();
      }
    });

    actionPanel.onClickBtn('multipleDownload', async () => {
      if (actionPanel.isDisabledBtn('multipleDownload')) {
        if (selectImage.array().length === 0) {
          alert(DISABLED_MULTIPLE_DOWNLOAD_MSG);
        } else {
          alert(LOCKED_MULTIPLE_DOWNLOAD_MSG);
        }
      } else {
        const availablePhotos = IMAGE_DATA.filter(photoDC.includesById(selectImage.array()));
        if (availablePhotos.length === 0) {
          alert(DISABLED_SHARE_MSG_BECAUSE_WATERMARK_MULTIPLE_DOWNLOAD);
        } else {
          await multipleDownload(availablePhotos, ATT_ID);
          selectImage.unselectAll();
        }
      }
    });

    selectedPanel.onClickClearBtn(selectImage.unselectAll);
  }

  function comparisonPhotosByWatermark(photoA, photoB) {
    if (isEnabledWatermarkBySrc(photoA.full_path) && !isEnabledWatermarkBySrc(photoB.full_path)) return 1;
    if (!isEnabledWatermarkBySrc(photoA.full_path) && isEnabledWatermarkBySrc(photoB.full_path)) return -1;
    return 0;
  }

  this.getSelfieList = function (attUid, callback, callbackError) {
    occoApi.profilePhotoListRetrieve(attUid, (err, result) => {
      if (err) {
        if (callbackError) {
          callbackError(err);
          return;
        }
        return alertMessagePopup(err.message_key);
      }
      if (callback) {
        callback(result);
      }
    });
  };

  this.newDownloadImage = function ({ id }) {
    waitingNotice.text('Downloading files.<br/>Please be patient.');
    waitingNotice.show();

    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    trackPhotoEvent({ activityName: 'Download', photoId: photo.id, attendeeUid: ATT_ID });
    const urlAsArray = photo.full_path.split('/');
    const fileName = urlAsArray[urlAsArray.length - 1];

    if (is360(photo)) {
      alert(
        'This is interactive content, best viewed within this album. You can still download the raw file to share online or view later in apps that recognize 360 spherical format.'
      );
    }

    downloadFile(photo.full_path, fileName).finally(waitingNotice.hide);
  };

  this.newShareImageUrl = function ({ id }) {
    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    shareFiles([photo]);
  };

  this.downloadImage = function ({ id }) {
    if (isIPhone()) {
      self.newShareImageUrl({ id });
    } else {
      self.newDownloadImage({ id });
    }
  };

  this.newShareImage = function ({ id }) {
    const photo = IMAGE_DATA.find(photoDC.isPhotoById(id));
    shareSharingPage(photo.thumb_full_path, [photo]);
  };
  function downloadFile(url, fileName) {
    return fetch(url)
      .then((res) => res.blob())
      .then((res) => {
        const aElement = document.createElement('a');
        aElement.setAttribute('download', fileName);
        const href = URL.createObjectURL(res);
        aElement.href = href;
        aElement.setAttribute('target', '_blank');
        aElement.click();
        URL.revokeObjectURL(href);
        aElement.remove();
      })
      .catch((e) => {
        console.error('downloadFile error:', e);
      });
  }

  function showFaceRegister(shouldRedirectToSelfiesPage, haveSelfies = true) {
    const text = haveSelfies ? ST_TEXTS.rightFaceMessage : ST_TEXTS.noSelfiesSugMessage;
    let content = `<div>
        <div>${text}</div><br>
        <div>${ST_TEXTS.noFaceMask}</div><br>
            <div class="faceUploadContApp">
            <span class="label label-info"> </span>
                <br />
                <label id='labelUploadFaceImagesApp'
                    class='btn btn-primary btn-lg btn-circle btn-camera'
                    for='photoFaceUploadButtonApp'><i class="fa fa-camera"></i></label>
                <input type='file' name='file' class='file-upload' id='photoFaceUploadButtonApp' accept="image/*" capture>
                    <br><br>`;

    if (!haveSelfies) {
      content += `<br>
           <button type = "button" class = "btn btn-primary btn-lg" data-dismiss = "modal" > Maybe Later </button>`;
    }
    content += '</div>';
    customPopUp.html(content);
    customPopUp.show();
    initAppSelfie(shouldRedirectToSelfiesPage);
  }

  function openDeleteImagesModal() {
    const selectedStockImage = IMAGE_DATA.filter(photoDC.isStockImage).filter(
      photoDC.includesById(selectImage.array())
    );
    const warningMassageText = `You have selected an event stock image to delete. <br>
        It cannot be deleted from your album and will be skipped.<br><br>`;
    const warningMassage = selectedStockImage.length > 0 ? warningMassageText : '';
    const content =
      `<div><h6>${warningMassage}Deleting images from your album can not be undone. Are you sure you want to proceed?` +
      ` </h6><br> <br>
        <div class="form-inline">
            <div class="controls-row">
                <div class="input-group">
                    <label class="radio inline">
                        <input type="radio" class="rDelReason" name="deletePhotosRadio" value="AttendeeDeletePhotoNotWanted" checked="" style="vertical-align: middle;margin-right:5px;">I don't want those images in my album
                    </label>
                </div>
                <div class="input-group">
                    <label class="radio inline">
                        <input type="radio" class="rDelReason" name="deletePhotosRadio" value="AttendeeDeletePhotoNotTheirs" style="vertical-align: middle;">
                        Those are not my images
                    </label>
                </div>
            </div>
        </div>
        <br>
        <button type="button" class="btn btn-light btn-lg" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-danger btn-lg" onClick="occoAppPages.deleteSelectedImages()">Yes, delete</button></div>`;

    customPopUp.html(content);
    customPopUp.show();
  }

  // NOTE: Is used in the function openDeleteImagesModal
  this.deleteSelectedImages = function () {
    const selectedStockImagesId = IMAGE_DATA.filter(photoDC.isStockImage)
      .filter(photoDC.includesById(selectImage.array()))
      .map(photoDC.id);
    let selectedPhotosIdWithoutStockImage = [];
    if (selectedStockImagesId.length > 0) {
      selectedPhotosIdWithoutStockImage = selectImage.array().filter(photoDC.notIncludesById(selectedStockImagesId));
    } else {
      selectedPhotosIdWithoutStockImage = selectImage.array();
    }
    const result = selectedPhotosIdWithoutStockImage;
    if (result.length === 0) {
      customPopUp.hide();
      return;
    }
    showLoading();
    deleteImagesReq(result, $('input:radio.rDelReason:checked').val(), EVENT_DATA.id, 'attendee_uid', ATT_ID, (err) => {
      customPopUp.hide();
      if (err) {
        alert(err.message_key);
        return;
      }
      selectImage.unselectAll();
      getImageList(EVENT_DATA.id);
    });
  };

  function initAppSelfie() {
    const $photoFaceUploadButtonApp = $('#photoFaceUploadButtonApp');
    $photoFaceUploadButtonApp.on('change', handle);
    const $photoFaceUploadButtonApp2 = $('#photoFaceUploadButtonApp2');
    $photoFaceUploadButtonApp2.on('change', handle);
    faceReco.show(EVENT_OPTS.FaceRecoTooltipText);

    function handle() {
      showLoading();
      Promise.all(Array.from(this.files).map((file) => uploadSelfieImage(file)))
        .then(() => globalThis.location.reload())
        .catch((e) => {
          if (e.message === LANG.unsupported_pic_format) {
            alert(LANG.unsupported_pic_format || 'Unsupported image format. Please use a different image file.');
          } else {
            alert('An error occurred while uploading your photo. Please try again or contact support.');
          }
          hideLoading();
          console.error(e);
        });
    }
  }
  function handlePhotoAIPhotoAttach(aiKioskImageSrc) {
    const content2 = `<div class="uploadMassage__Text">
      <div>${LANG.asyncUGCUploadText}</div><br>
      <button id="aiKioskOk" type="button" class="btn btn-primary btn-lg" data-dismiss="modal">OK</button>
    </div>`;

    customPopUp.html(content2);
    customPopUp.show();
    onCloseModal(() => {
      updatePageQueryString(filterQuery(filterKeys(['aiKioskImgSrc', 'aiKiosk'])));
    });

    const $aiKioskOk = $('#aiKioskOk');
    $aiKioskOk.click(() => {
      occoApi.miniAlbumcreateCustomPhoto(EVENT_NAME, aiKioskImageSrc, ATT_ID, (err) => {
        if (err && err.message_key === 'attendee_upload_limit_reached') {
          alertMessagePopup(
            'You have reached your photo upload limit. Please contact support if you need to upload more photos.'
          );
        } else if (err) {
          return alert(err.message_key);
        }
      });
    });
  }

  function handlePhotoUpload({
    prefixFileName = '',
    asyncUgcUploadText = EVENT_OPTS.UGCProcessMessage ? EVENT_OPTS.UGCProcessMessage : LANG.asyncUGCUploadText,
    ugcUploadMessage = EVENT_OPTS.UGCUploadMessage ? EVENT_OPTS.UGCUploadMessage : LANG.uploadUGCTxt,
  } = {}) {
    UGC.Off();
    const content = `<div class="uploadMassage__Text">
              <div">${ugcUploadMessage}</div><br>
              <label type="button" class="btn btn-primary btn-lg"  for='photoUploadButtonOk'> Ok</label>
              <input type='file' name='file' class='file-upload'  id='photoUploadButtonOk' accept='image/*'  multiple />
          </div>`;
    customPopUp.html(content);
    customPopUp.show();
    if (IMAGE_DATA.length === 0) {
      $('#customUpload').css({
        position: 'relative',
        margin: '0 auto',
      });
    }
    const eventName = EVENT_DATA.name;
    const $photoUploadButtonOk = $('#photoUploadButtonOk');
    let activeFileSession;
    $photoUploadButtonOk.click(() => {
      activeFileSession = true;
    });
    const handler = (i, total, file) =>
      new Promise((resolve) => {
        $('#customUpload').css({
          position: 'absolute',
        });
        customImageUpload(file, {
          opts: EVENT_OPTS,
          eventId: Math.floor(Math.random() * 10001),
          eventName,
          attendeeUid: ATT_ID || null,
          generateFileName: true,
          prefixFileName,
          fileRootPath: 'usersCustomPhotos/',
          callbackAdd() {},
          callbackSuccess(imgPath) {
            occoApi.miniAlbumcreateCustomPhoto(eventName, imgPath, ATT_ID, (err) => {
              if (err && err.message_key === 'attendee_upload_limit_reached') {
                alert(
                  'You have reached your photo upload limit. Please contact support if you need to upload more photos.'
                );
              } else if (err) {
                alert(
                  err.message_key ||
                    'An error occurred while processing your photo. Please try again or contact support.'
                );
                return;
              }
              const isUploadLastPhoto = total === i;
              if (!activeFileSession && isUploadLastPhoto) {
                getImageList(EVENT_DATA.id);
              }
              resolve();
            });
          },
        });
      });
    $photoUploadButtonOk.change(async function () {
      customPopUp.hide();
      activeFileSession = false;
      // showPreviewLoadingImages(this.files);
      showLoading();
      if (this.value !== '') {
        const fileLength = this.files.length;
        for (let i = 0; i < fileLength; i += 1) {
          await handler(i, fileLength - 1, this.files[i]);
        }
      } else if (!activeFileSession) {
        getImageList(EVENT_DATA.id);
      }
      const content2 = `<div class="uploadMassage__Text">
      <div>${asyncUgcUploadText}</div><br>
      <button id="close" type="button" class="btn btn-primary btn-lg" data-dismiss="modal"> OK </button>
      </div>`;
      customPopUp.html(content2);
      customPopUp.show();
      onCloseModal(() => {
        updatePageQueryString(filterQuery(filterKeys(['uploadUGC', 'tg'])));
      });
    });
  }
  this.showQRcode = function () {
    const showMyQRTEXT = ST_TEXTS.showMyQRWA;
    const attendeeId = ATT_ID;

    const content =
      `<div style="overflow-wrap: break-word;">
        <span class="" style="font-size:large;">${showMyQRTEXT}</span><br><br>
        <div id="qrCodeContShow"></div><br><span style="font-size:x-large;font-weight:bold;text-transform:uppercase;">${attendeeId}</span>` +
      `<div>
        <button type="button" data-dismiss="modal" class="btn btn-primary" style="border-radius: 20px;font-size: x-large;margin-top: 5px;">
            Close
        </button>
        </div>`;
    customPopUp.html(content);
    customPopUp.show();
    const $qrCodeCont = $('#qrCodeContShow');
    $qrCodeCont.html('');
    $qrCodeCont.qrcode({
      text: attendeeId,
      label: attendeeId,
      size: 200,
      mode: 0,
      mSize: 0.045,
      mPosX: 0.5,
      mPosY: 0.5,
      fontcolor: '#000',
      fontname: 'Arial',
      ecLevel: 'H',
      render: 'image',
    });

    $('#scanQR').qrCodeReader({
      callback(code) {
        console.log('code', code);
        if (code) {
          showScannedImage(parseCode(code), {
            onSubmit: (photoUId) => {
              attendeeAttachPhotosByQR(ATT_ID, [photoUId]);
            },
          });
        }
      },
    });
  };

  // code = "https://dev-images.occo.io/ntij/0706dff0-bef8-11eb-b096-8baa8b5fac4a/2021/4/4/CUSTOM_2021_05_27_02_30_04.jpg&&&098637d0-bef8-11eb-ac40-9f850beb"
  function parseCode(code) {
    let scannedImgSrc;
    let photoUId;

    if (hasSubscribing('&&&', code)) {
      [scannedImgSrc, photoUId] = code.split('&&&');
    } else if (hasSubscribing('http', code)) {
      const [, rawQueryString] = code.split('?');
      const query = new URLSearchParams(rawQueryString);
      scannedImgSrc = query.get('imgSrc');
      photoUId = query.get('photoId');
    }

    if (scannedImgSrc === undefined || photoUId === undefined) {
      console.error('Not defined scannedImgSrc or photoUID', {
        scannedImgSrc,
        photoUId,
      });
    }

    return {
      scannedImgSrc,
      photoUId,
    };

    function hasSubscribing(substring, string) {
      return string.indexOf(substring) > -1;
    }
  }

  function showScannedImage(
    { scannedImgSrc, photoUId },
    { isHideAfterFinish = true, onSubmit = async () => {}, onCancel = async () => {}, onFinish = async () => {} } = {}
  ) {
    if (scannedImgSrc && photoUId) {
      const content = `<div>
        <span class="">${ST_TEXTS.scannedImage}</span><br><br>
        <img class="scanned-img" src="${scannedImgSrc}" alt=""><br><br>
        <button type='button' id="cancelAttachPhoto"  class='btn btn-primary btn-lg' data-dismiss = "modal" >No</button>&nbsp;&nbsp;
        <button type='button'  id="attachPhoto" class='btn btn-primary btn-lg'  >Yes</button>
        </div><br>`;
      customPopUp.html(content);
      customPopUp.show();
      const finish = async () => {
        if (isHideAfterFinish) {
          customPopUp.hide();
        }
        await onFinish(photoUId);
      };
      $('#attachPhoto').on('click', async () => {
        await onSubmit(photoUId);
        await finish();
      });
      $('#cancelAttachPhoto').on('click', async () => {
        await onCancel(photoUId);
        await finish();
      });
    } else {
      console.error('Not defined scannedImgSrc or photoUID', {
        scannedImgSrc,
        photoUId,
      });
    }
  }

  function initQRReader({ isDisableLinkPhotos = false } = {}) {
    if (!isSessionExpired(multiAccounts.getCurrentAccount().regDate, EVENT_OPTS)) {
      $('.body').removeClass('qr_disabled');

      const $btn = $(`#openQRreader`);
      if (isDisableLinkPhotos) {
        // Mode for showing own QR code
        updateQRMenuText(true);
        $btn.click(self.showQRcode);
      } else {
        // Mode for scanning QR code
        updateQRMenuText(false);
        $btn.removeClass('qr-btn');
        $btn.qrCodeReader({
          callback(code) {
            if (code) {
              // code = "https://east.storibox.com/rc/gnt1.html?mrc1=ba953fd0-552f-11ec-9271-15253813d6a6";
              const codeMRC1 = getParameterByName('mrc1', code);
              if (codeMRC1 !== null) {
                remoteCapture(ATT_ID, codeMRC1);
              } else {
                captureEvents({
                  EventSource: 'WebApp',
                  EventName: 'QRScan',
                  EventType: 'info',
                  EventCode: EVENT_NAME,
                });
                showScannedImage(parseCode(code), {
                  onSubmit: (photoUId) => {
                    attendeeAttachPhotosByQR(ATT_ID, [photoUId]);
                  },
                });
              }
            }
          },
        });
      }
    }
  }

  function shareFiles(photos) {
    shareFilesBySrcs(photos.map(photoDC.src));
    trackListOfPhotoEvent({ activityName: 'Download', listOfPhotoId: photos.map(photoDC.id), attendeeUid: ATT_ID });
  }

  function shareFilesExec(files) {
    if (navigator.canShare && navigator.canShare({ files })) {
      navigator
        .share({
          files,
          title: 'Media',
        })
        .then(() => console.log('Successful share.'))
        .catch((error) => console.log('Failed or canceled share.', error));
    } else {
      alert(
        'Your browser does not support sharing files. Please use a different browser or download the files directly.'
      );
    }
  }

  async function shareFilesBySrcs(srcs) {
    waitingNotice.bottomOffset('84px');
    waitingNotice.text('Downloading files for sharing.<br/>Please be patient.');
    waitingNotice.show();

    return downloadFiles(srcs).then(shareFilesExec).finally(waitingNotice.hide);

    function getNameByUrl(url) {
      const array = url.split('/');
      return array[array.length - 1];
    }

    async function downloadFiles(listOfSrc) {
      return new Promise(async (resolve, reject) => {
        const files = [];
        for (const src of listOfSrc) {
          try {
            const res = await fetch(src);
            const file = new File([await res.blob()], getNameByUrl(src), {
              type: res.headers.get('Content-Type'),
            });
            files.push(file);
          } catch (error) {
            reject(error);
          }
        }
        resolve(files);
      });
    }
  }

  function onCloseModal(cb) {
    $('#customPopUp .close').click(cb);
    $('[data-dismiss="modal"]').click(cb);
  }

  function getTextForWaitingStory(opts) {
    return opts.textWaitingStories || DEFAULT_TEXT_WAITING_STORIES;
  }

  function getRequiredTagsToGenerateStory() {
    return EVENT_OPTS.requiredTagsToGenerateStory ? EVENT_OPTS.requiredTagsToGenerateStory.split(',') : [];
  }

  function isUidNull() {
    const regExp = /null/i;
    return regExp.test(getQueryVariable('uId'));
  }

  function shareSharingPage(previewImg, photos) {
    return shareBucketApi
      .uploadFile({
        folderPath: `${EVENT_DATA.name}/`,
        file: prepareSharePage({
          ogpData: {
            title: EVENT_DATA.opts.webappOGPTitle,
            description: EVENT_DATA.opts.webappOGPDesc,
            image: previewImg,
          },
          eventCode: EVENT_DATA.name,
          attendeeUid: ATT_ID,
          photoData: photos,
        }),
      })
      .then((url) => {
        const transformedUrl = transformS3UrlToShareDomain(url);
        shareUrl({ text: EVENT_DATA.opts.webappShareTitle, url: transformedUrl });
        return transformedUrl;
      })
      .then((url) => {
        const timestreamEvents = [
          {
            EventSource: 'Webapp',
            EventName: 'SHARE_LINK',
            EventType: 'report',
            EventId: EVENT_DATA.id,
            EventCode: EVENT_DATA.name,
            AttendeeUid: ATT_ID,
            Count: photos.length,
            EventHref: globalThis.location.href,
            EventUrl: url,
          },
        ];

        photos.forEach(({ id, image_process_id }) =>
          timestreamEvents.push({
            EventSource: 'Webapp',
            EventName: 'FacebookShare',
            EventType: 'report',
            EventId: EVENT_DATA.id,
            EventCode: EVENT_DATA.name,
            AttendeeUid: ATT_ID,
            PhotoId: id,
            Count: 1,
            PipelineId: image_process_id,
            EventHref: globalThis.location.href,
          })
        );

        return captureEvents(timestreamEvents);
      })
      .catch((error) => {
        if (error.message_key) {
          alertMessagePopup(error.message_key);
        } else {
          alertMessagePopup(error.message);
        }
      });
  }
}

const occoAppPages = new OCCOAppPages();

occoAppPages.init();

globalThis.occoAppPages = occoAppPages;
